module.exports = __webpack_public_path__ + "media/images/about-cover-60380741d9350ca70400c686f9c3ff48.png";